export default __webpack_public_path__ + "static/media/Minicard_Kd.a37cb2ab.svg";